export default __webpack_public_path__ + "static/media/left-arrow.e0f54ea6.svg";